module.exports = __webpack_public_path__ + "img/threedimg.6c7b5a34.svg";